const defaultBlacklist = {
  a: true,
  an: true,
  the: true,
  at: true,
  by: true,
  'for': true,
  'in': true,
  'of': true,
  on: true,
  to: true,
  up: true,
  and: true,
  'as': true,
  but: true,
  or: true,
  nor: true,
}

const capitalizeWord = word => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;

module.exports = (phrase, blacklist = defaultBlacklist) => {
  return phrase.split(' ')
    .map(word => word.toLowerCase())
    .map((word, index) => {
      return index == 0 ? capitalizeWord(word)
        : !blacklist[word] ? capitalizeWord(word)
        : word.toLowerCase();
    })
    .join(' ');
}
